import React from 'react';
import { Button, Typography } from 'antd';
import styled from 'styled-components';
import { PrimaryColor } from 'GlobalStyles';
import { FormWrapper } from 'GlobalStyles';
import BackgroundSource from 'assets/images/banners/12.webp';

const { Text, Title } = Typography;
const CompletedWrapper = styled.div`
  padding: 10px;
  text-align: center;
  background: no-repeat url(${BackgroundSource});
  background-position: center center;
  a.ant-btn-lg {
    line-height: 26px;
  }
`;
const Completed = () => {
  return (
    <CompletedWrapper>
      <FormWrapper style={{ maxWidth: '380px' }}>
        <Title level={2}>
          <span style={{ color: `${PrimaryColor}` }}>결제가 완료되었습니다.</span>
        </Title>
        <Text style={{ margin: '20px auto', display: 'block' }}>
          결제가 정상적으로 처리되었습니다.
          <br />
          바로 시작하세요.
        </Text>
        <Button
          style={{ width: '100%', height: '45px', lineHeight: '45px' }}
          type='primary'
          size='large'
          href='/'
        >
          홈으로 이동하기
        </Button>
      </FormWrapper>
    </CompletedWrapper>
  );
};

export default Completed;
